// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FourColumnsRounded {
    flex-direction: column;
    align-items: flex-start;
}

.FourColumnsRoundedImg-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    padding-top: 100px;
    padding-bottom: 60px;
}

.OverlayText {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    position: absolute;
    z-index: 1;
    width: 80%;
    height: 100%;
}

.OverlayText-space {
    height: 60%;
}

.OverlayText-content {
    text-align: center;
}

.OverlayText h3 {
    color: white;
    font-size: 2rem;
    font-weight: 900;
}

.OverlayText h3,
.OverlayText span {
    text-align: center;
    line-height: 1.2;
    font-family: Poppins;
}

.OverlayText span {
    font-size: 1.1rem;
    margin: 0;
    color: white;
    max-width: 280px;
}

.FourColumnsRounded .ant-card-body {
    padding: 0px !important;
}

.FourCard {
    width: 100%;
}

.Image {
    background: #000;
    position: relative;
    border-radius: 40px;
    margin: 0 10px;
    justify-content: center;
}

/* .Image::before { 
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 328px;
    height: 100%;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7));
    opacity: 1;
    border-radius: 32px; 
}*/

.Image-bg {
    background-size: cover;
    background-position: center center;
    border-radius: 32px;
    width: 100%;
    aspect-ratio: 0.6 / 1;
    /* mask-image: linear-gradient(#000, transparent); */
    max-height: 570px;
}

.Image-bg {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    border-radius: 32px;
}`, "",{"version":3,"sources":["webpack://./src/css/FourColumnsRoundedImg.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;;;;;;;;;;;EAWE;;AAEF;IACI,sBAAsB;IACtB,kCAAkC;IAClC,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,oDAAoD;IACpD,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;AACvB","sourcesContent":[".FourColumnsRounded {\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.FourColumnsRoundedImg-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n    padding-top: 100px;\n    padding-bottom: 60px;\n}\n\n.OverlayText {\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: center;\n    position: absolute;\n    z-index: 1;\n    width: 80%;\n    height: 100%;\n}\n\n.OverlayText-space {\n    height: 60%;\n}\n\n.OverlayText-content {\n    text-align: center;\n}\n\n.OverlayText h3 {\n    color: white;\n    font-size: 2rem;\n    font-weight: 900;\n}\n\n.OverlayText h3,\n.OverlayText span {\n    text-align: center;\n    line-height: 1.2;\n    font-family: Poppins;\n}\n\n.OverlayText span {\n    font-size: 1.1rem;\n    margin: 0;\n    color: white;\n    max-width: 280px;\n}\n\n.FourColumnsRounded .ant-card-body {\n    padding: 0px !important;\n}\n\n.FourCard {\n    width: 100%;\n}\n\n.Image {\n    background: #000;\n    position: relative;\n    border-radius: 40px;\n    margin: 0 10px;\n    justify-content: center;\n}\n\n/* .Image::before { \n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    max-width: 328px;\n    height: 100%;\n    background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7));\n    opacity: 1;\n    border-radius: 32px; \n}*/\n\n.Image-bg {\n    background-size: cover;\n    background-position: center center;\n    border-radius: 32px;\n    width: 100%;\n    aspect-ratio: 0.6 / 1;\n    /* mask-image: linear-gradient(#000, transparent); */\n    max-height: 570px;\n}\n\n.Image-bg {\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    border-radius: 32px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
